import "./App.css";
import { loadEmailTemplates } from "./utils/emailTemplateLoader";
import { loadTeamDefaults } from "./utils/teamDefaults";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Dashboard from "./pages/dashboard";
import { useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signOut,
  getAuth, // ✅ Local Persistence
} from "firebase/auth";
import { auth, messaging } from "./firebase/firebaseConfig";
import Login from "./pages/Login";
// import Signup from "./pages/Signup";
import { toast, ToastContainer } from "react-toastify";
import { actionType } from "./context/reducer";
import { getuserinformation } from "./utils/firebasefunctions";
import { useStateValue } from "./context/StateProvider";
import Signup from "./pages/Signup";
import { onMessage } from "firebase/messaging";
import Message from "./components/Message";
import Privacypolicy from "./pages/Privacypolicy";
import Termsandservice from "./pages/Termsandservice";
import PublicFeedback from "./pages/public-feedback";

function App() {
  const [user, setUser] = useState(null);
  const [{ userDetails }, dispatch] = useStateValue();
  const [loading, setLoading] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("Logged out successfully!");
      setUser(null);
      dispatch({ type: actionType.SET_USER, payload: null });
    } catch (error) {
      toast.error("Logout failed. Please try again.");
      console.error("Logout Error:", error);
    }
  };

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userInfo = await getuserinformation("users", user.uid);
          // if (userInfo.role === "Accountant") {
          //   await auth.signOut();
          //   return;
          // }

          // 🔒 BLOCK deleted user
          if (userInfo?.type === 1) {
            toast.error(
              "Your account has been deleted. Kindly contact Administrator",
            );
            await auth.signOut();
            dispatch({ type: actionType.SET_USER, payload: null });
            setUser(null);
            setLoading(false);
            return;
          }

          // 🔒 BLOCK disabled user
          if (userInfo?.type === 2) {
            toast.error(
              "Your account has been disabled. Kindly contact Administrator",
            );
            await auth.signOut();
            dispatch({ type: actionType.SET_USER, payload: null });
            setUser(null);
            setLoading(false);
            return;
          }

          // ✅ Allowed user
          dispatch({ type: actionType.SET_USER, payload: userInfo });
          loadEmailTemplates().then((tmap) => {
            dispatch({ type: actionType.SET_EMAIL_TEMPLATES, payload: tmap });
          });
          loadTeamDefaults().then((td) => {
            dispatch({ type: actionType.SET_TEAM_DEFAULTS, payload: td });
          });
          setUser(userInfo);
        } catch (error) {
          console.error("Error fetching user info:", error);
          await auth.signOut();
          dispatch({ type: actionType.SET_USER, payload: null });
          setUser(null);
        }
      } else {
        dispatch({ type: actionType.SET_USER, payload: null });
        setUser(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);







  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  const PrivateRoute = ({ children }) => {
    return user ? children : <Navigate to="/" replace />;
  };

  // ✅ Redirect Logged-in Users to Dashboard
  const PublicRoute = ({ children }) => {
    return user ? (
      <Navigate
        to={user?.role === "Supervisor" ? "/dashboard/deals" : "/dashboard"}
        replace
      />
    ) : (
      children
    );
  };

  // 🚧 Handle Invalid Routes
  const NotFoundRoute = () => <Navigate to={user ? "/dashboard" : "/"} />;

    onMessage(messaging, (payload) => {
    toast(<Message notification={payload.data} />);
  });

  return (
    <main className="w-full">
     
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              {/* <Signup /> */}
              <Login />
            </PublicRoute>
          }
        />
        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route
          path="/dashboard/*"
          element={
            // <PrivateRoute>
            <Dashboard onLogout={handleLogout} />
            
            // </PrivateRoute>
          }
        />
   <Route
          path="/PrivacyPolicy"
          element={
            // <PrivateRoute>
            <Privacypolicy  />
            
            // </PrivateRoute>
          }
        />
 <Route
          path="/TermsAndService"
          element={
            // <PrivateRoute>
            <Termsandservice  />
            
            // </PrivateRoute>
          }
        />
        
  
        <Route path="/feedback" element={<PublicFeedback />} />
        <Route path="*" element={<NotFoundRoute />} />
      </Routes>
      <ToastContainer
           position="top-right"
          autoClose={3000}
          hideProgressBar={true}
       
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          type="error"
          pauseOnHover
          theme="light"
      />
    </main>
  );
}

export default App;
